export const MAP_ACCESS_TOKEN =
  "pk.eyJ1Ijoic3VoYWlsLWFwcCIsImEiOiJjazl0cjFrOWMxZ2p1M2huMW4xZTl2MzgzIn0.GMPVuCC_3EpJ4HZA8KZoPg";

export const ORDER_STATUS = {
  DRAFT: "Draft",
  INITIAL: "Initial",
  REVIEWING: "Reviewing",
  WAITING_APPROVAL: "WaitingApproval",
  WAITING_RST_TAX: "WatingRstTax",
  WAITING_TRANSACTION: "WatingTransaction",
  WAITING_REFUND: "WaitingRefund",
  COMPLETED: "Complete",
  CANCELED: "Canceled",
};

export const ONLINE_ORDER_STATUS = {
  Draft: "Draft",
  WaitingDownPayment: "WaitingDownPayment",
  WaitingOnlinePayments: "WaitingOnlinePayments",
  WaitingAdminFeesPayment: "WaitingAdminFeesPayment",
  WaitingSeriousnessFees: "WaitingSeriousnessFees",
  WaitingBankApproval: "WaitingBankApproval",
  PaymentRealEstateTax: "PaymentRealEstateTax",
  PaymentRealEstateTaxFree: "PaymentRealEstateTaxFree",
  WatingTransaction: "WatingTransaction",
  WaitingRefund: "WaitingRefund",
  CanceledRefundDone: "Canceled_RefundDone",
  Complete: "Complete",
  Canceled: "Canceled",
};

export const ORDER_TYPES = {
  installment: "installment",
  fullPayment: "fullPayment",
  offPlan: "offPlan",
  mortgageLoan: "mortgageLoan",
};

export const ORDER_PAYMENT_TYPES_FILTER = [
  { value: "دفعة كاملة", key: 0 },
  { value: "دفعات", key: 1 },
  { value: "تمويل عقاري", key: 2 },
  { value: "الدفع حسب الإنجاز", key: 3 },
];

export const INVOICE_STATUS = {
  INVOICE_STATUS__COLLECTED: "INVOICE_STATUS__COLLECTED",
  INVOICE_STATUS__BILL_CREATED: "INVOICE_STATUS__BILL_CREATED",
  INVOICE_STATUS__CREATED: "INVOICE_STATUS__CREATED",
};

export const BATCH_STATUS = {
  BATCH_STATUS__NEW: "BATCH_STATUS__NEW",
  BATCH_STATUS__LISTED: "BATCH_STATUS__LISTED",
  BATCH_STATUS__UNLISTED: "BATCH_STATUS__UNLISTED",
  BATCH_STATUS__LOCKED: "BATCH_STATUS__LOCKED",
  BATCH_STATUS__CANCELED: "BATCH_STATUS__CANCELED",
  BATCH_STATUS__SOLD: "BATCH_STATUS__SOLD",
};

export const SALES_CHANNELS = {
  SALES_CHANNELS__WEHDAT_OFFLINE: "SALES_CHANNELS__WEHDAT_OFFLINE",
  SALES_CHANNELS__WEHDAT_MARKETPLACE: "SALES_CHANNELS__WEHDAT_MARKETPLACE",
};

export const MAP_DATA_TYPE = {
  PARCEL: "PARCEL",
  ORDER: "ORDER",
  CREATE_ORDER: "CREATE_ORDER",
  UPDATE_ORDER: "UPDATE_ORDER",
  BATCH: "BATCH",
  CREATE_BATCH: "CREATE_BATCH",
  UPDATE_BATCH: "UPDATE_BATCH",
  UNITS_GROUP: "UNITS_GROUP",
  CREATE_UNITS_GROUP: "CREATE_UNITS_GROUP",
  UPDATE_UNITS_GROUP: "UPDATE_UNITS_GROUP",
};

export const SALES_TYPE = {
  INDIVIDUAL: "Individual",
  ORGANIZATION: "Organization",
};

export const SALES_TYPE_MAPPING = {
  Individual: "فرد",
  Organization: "شركة",
};

export const ORG_TYPES = [
  { id: "Company", name: "شركة" },
  { id: "NonProfitOrganization", name: "مؤسسة غير ربحية" },
  { id: "IndividualFacility", name: "منشأة فردية" },
];

export const STATUS_COLOR = {
  Draft: "#C5C7D2",
  Initial: "#DFFFF5",
  Reviewing: "#FFD98D",
  WaitingApproval: "#C8B8F7",
  WatingRstTax: "#BFF9C8",
  WatingTransaction: "#D75281",
  Complete: "#8490F980",
  Canceled: "#F8B3B3",
};

export const STATUS_MAPPING = {
  Draft: "مسودة",
  Initial: "طلب أولي",
  Reviewing: "قيد المراجعة",
  WaitingApproval: "في انتظار الموافقة",
  WatingRstTax: "إرفاق ضريبة التصرفات العقارية",
  WatingTransaction: "إفراغ الصك",
  Complete: "مكتمل",
  Canceled: "ملغي",
};

export const PARCELS_MAPPING = {
  available: "متاحة",
  unavailable: "غير متاحة",
  booked: "محجوزة",
  tanfeeth: "قيد التنفيذ",
  waitingtax: "بانتظار دفع الضريبة",
  sold: "مباعة",
};

export const PARCELS_COLOR = {
  available: "#457b9d",
  unavailable: "#94D2BD",
  booked: "#1d3557",
  tanfeeth: "#FA9494",
  waitingtax: "#F7A76C",
  sold: "#e63946",
};

export const PARCELS_HOVER_COLOR = {
  available: "rgba(69, 123, 157,0.8)",
  unavailable: "rgba(148, 210, 189,0.8)",
  booked: "rgba(29, 53, 87,0.8)",
  tanfeeth: "rgba(250,148,148,0.8)",
  waitingtax: "rgba(247, 167, 108,0.8)",
  sold: "rgba(230, 57, 70,0.8)",
};

export const PARCELS_OPACITY_COLOR = {
  available: "rgba(69, 123, 157,0.3)",
  unavailable: "rgba(148, 210, 189,0.3)",
  booked: "rgba(29, 53, 87,0.3)",
  tanfeeth: "rgba(250,148,148,0.3)",
  waitingtax: "rgba(247, 167, 108,0.3)",
  sold: "rgba(230, 57, 70,0.3)",
};

export const ORGANIZATION_SYSTEMS_MAPPING = [
  { value: "BookingModuleEnabled", title: "نظام الحجوزات" },
  {
    value: "BrokerageOfficeModuleEnabled",
    title: "نظام ادارة العروض",
  },
  {
    value: "TransactionsTrackerModuleEnabled",
    title: "نظام تتبع الصفقات",
  },
];

export const GENERAL_ORDER_STATUS = [
  {
    name: "مسودة",
    key: "Draft",
    color: "#C5C7D2",
  },
  {
    name: "طلب أولي",
    key: "Initial",
    color: "#DFFFF5",
  },
  {
    name: "قيد المراجعة",
    key: "Reviewing",
    color: "#FFD98D",
  },
  {
    name: "في انتظار الموافقة",
    key: "WaitingApproval",
    color: "#C8B8F7",
  },
  {
    name: "إرفاق ضريبة التصرفات العقارية",
    key: "WatingRstTax",
    color: "#BFF9C8",
  },
  {
    name: "إفراغ الصك",
    key: "WatingTransaction",
    color: "#D75281",
  },
  {
    name: "مكتمل",
    key: "Complete",
    color: "#8490F980",
  },
  {
    name: "ملغي",
    key: "Canceled",
    color: "#F8B3B3",
  },
];

export const OFFERS_STATUS_MAPPING = {
  DRAFT: "مسودة",
  PUBLISHED: "نشط",
  INVALID: "مباع",
  DELETED: "محذوف",
  UNPUBLISHED: "معطل",
  EXPIRED: "معطل",
  INVALIDDATA: "معطل",
  CANCELD: "معطل",
};

export const OFFERS_STATUS_COLOR = {
  DRAFT: { backgroundColor: "#F2F2F2", color: "#556E7A" },
  PUBLISHED: { backgroundColor: "#E4F2FD", color: "#15489F" },
  INVALID: { backgroundColor: "#FFF3E0", color: "#B3261E" },
  DELETED: { backgroundColor: "#FFD0D0", color: "#EE2727" },
  UNPUBLISHED: { backgroundColor: "#FFD0D0", color: "#EE2727" },
  EXPIRED: { backgroundColor: "#FFF3E0", color: "#B3261E" },
  INVALIDDATA: { backgroundColor: "#FFF3E0", color: "#B3261E" },
  CANCELD: { backgroundColor: "#FFD0D0", color: "#EE2727" },
};

export const ROLES_MAPPING = {
  Manager: "مسؤول النظام",
  ExecutionManager: "مدير التنفيذ",
  FinancialManager: "مدير مالي",
  Coordinator: "منسق",
  Officer: "مندوب مبيعات",
};

export const ROLES = [
  { value: "Manager", title: "مسؤول النظام" },
  { value: "ExecutionManager", title: "مدير التنفيذ" },
  { value: "FinancialManager", title: "مدير مالي" },
  { value: "Coordinator", title: "منسق" },
  { value: "Officer", title: "مندوب مبيعات" },
];

export const PREREQUISITE_FIELDS_TYPE = {
  FreeText: "FreeText",
  Confirmation: "Confirmation",
  Attachment: "Attachment",
  FinancialProof: "FinancialProof",
};

export const ORDER_SCOPE = {
  block: "BY_BLOCK",
  sameBlock: "SAME_BLOCK",
  parcel: "BY_PARCEL",
};

export const MONTHS = [
  "يناير",
  "فبراير",
  "مارس",
  "إبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];

export const DAYS = {
  0: "الأحد",
  1: "الإثنين",
  2: "الثلاثاء",
  3: "الأربعاء",
  4: "الخميس",
  5: "الجمعة",
  6: "السبت",
};

export const MAP_LEVELS_LABELS = {
  // 0: "جميع الأدوار",
  1: "الدور الأول",
  2: "الدور الثاني",
  3: "الدور الثالث",
  4: "الدور الرابع",
  5: "الدور الخامس",
  6: "الدور السادس",
  7: "الدور السابع",
  8: "الدور الثامن",
  9: "الدور التاسع",
  10: "الدور العاشر",
};

export const PROJECT_TYPES = {
  parcels: "قطع أراضي",
  apartment: "شقق",
  floor: "أدوار",
  villa: "فلل مستقلة",
  townhouse: "تاون هاوس",
};

export const PROPERTIES_TYPES = {
  apartment: "شقة",
  villa: "فيلا مستقلة",
  townhouse: "تاون هاوس",
  floor: "دور",
};

export const PARTNER_ERROR_CODES = {
  PartnerCreate_DuplicateRecord__719:
    "الشريك مسجل بالفعل. يرجى التحقق من المعلومات لتجنب التكرار",
  PartnerCreate_PercentExceedLimit__720:
    "النسبة المدخلة تزيد عن الحد المسموح به. يرجى إدخال قيمة صحيحة",
  PartnerUpdate_PercentExceedLimit__721:
    "النسبة المدخلة تزيد عن الحد المسموح به. يرجى إدخال قيمة صحيحة",
  PartnerUpdate_PartnerIdNotAssociatedToProjectId__722:
    "هوية الشريك لا تتطابق مع هوية المشروع. يرجى التحقق من البيانات والمحاولة مجددًا",
  PartnerCreate_BillerNotFound__726:
    "غير مسموح بهذا الاجراء, تأكد من وجود البيانات البنكية لسهيل من فريق التطوير",
  PartnerCreate_PartnerIdInvalid__727:
    "غير مسموح بهذا الاجراء, أنت تحاول اضافة نسبة لمشروع برقم تعريف خاطئ",
  LessThanOrEqualValidator: "قيمة خاظئة, الرجاء ادخال قيمة تتراوح من 0 الى 100",
};

export const BADGES_STATUS = {
  in_progress: { nameEn: "in progress", name: "قيد الإنشاء", color: "#C5C7D2" },
  submitted: { nameEn: "submitted", name: "جاري التحقق", color: "#C5C7D2" },
  rejected: { nameEn: "rejected", name: "تم الرفض", color: "#F8B3B3" },
  approved: { nameEn: "approved", name: "تم القبول", color: "#BFF9C8" },
};

export const BADGE_FIELDS = [
  { title: "الاسم الأول", key: "firstName" },
  { title: "الاسم الأخير", key: "lastName" },
  { title: "رقم الهاتف", key: "phoneNumber" },
  { title: "رقم الوثيقة", key: "idNumber" },
  { title: "رخصة فال", key: "falNumber" },
  { title: "تاريخ انتهاء الترخيص", key: "falNumberEndDate" },
];

export const TRANSACTIONS_VIEW_TYPE = {
  SUBDIVISON: "Subdivision",
  PARCEL: "Parcel",
};

export const MAP_LEGENDS = [
  {
    mode: "plain",
    label: "",
    legends: [],
  },
  {
    mode: "transactions_count",
    title: "عدد الصفقات",
    label: "Transactions Count",
    legends: [
      {
        value: "0",
        color: "#F1CE63",
      },
      {
        value: "1",
        color: "#7AD151",
      },
      {
        value: "2",
        color: "#1C9D97",
      },
      {
        value: "3",
        color: "#424DCD",
      },
      {
        value: "4 - 7",
        color: "#9863BD",
      },
      {
        value: "8 <",
        color: "#C9068B",
      },
    ],
  },
  {
    mode: "shape_area",
    title: "المساحة",
    label: "المساحة . متر مربع",
    stops: [
      { value: 0, color: "hsl(86, 83%, 65%)", percent: "0%" },
      { value: 300, color: "hsl(64, 63%, 53%)", percent: "10% " },
      { value: 400, color: "hsl(42, 80%, 55%)", percent: "20%" },
      { value: 500, color: "hsl(25, 100%, 61%)", percent: "30%" },
      { value: 600, color: "hsl(8, 100%, 66%)", percent: "40%" },
      { value: 700, color: "hsl(348, 100%, 66%)", percent: "50%" },
      { value: 800, color: "hsl(331, 83%, 60%)", percent: "65%" },
      { value: 900, color: "hsl(312, 56%, 51%)", percent: "85%" },
      { value: 1200, color: "hsl(266, 45%, 46%)", percent: "100%" },
    ],
    ranges: ["0-300", "300-500", "500-700", "700-900", ">1200"],
  },
  {
    mode: "price_of_meter",
    title: "سعر المتر",
    label: "متوسط سعر المتر . ريال سعودي لكل متر مربع",
    stops: [
      { value: 0, color: "hsl(0, 0%, 80%)", percent: "0%" },
      { value: 109, color: "hsl(64, 63%, 53%)", percent: "10% " },
      { value: 180, color: "hsl(42, 80%, 55%)", percent: "20%" },
      { value: 287, color: "hsl(25, 100%, 61%)", percent: "30%" },
      { value: 478, color: "hsl(8, 100%, 66%)", percent: "40%" },
      { value: 750, color: "hsl(348, 100%, 66%)", percent: "50%" },
      { value: 1150, color: "hsl(331, 83%, 60%)", percent: "65%" },
      { value: 1900, color: "hsl(312, 56%, 51%)", percent: "85%" },
      { value: 3150, color: "hsl(266, 45%, 46%)", percent: "100%" },
    ],
    ranges: ["0-200", "200-500", "500-800", "800-1000", ">3000"],
  },
  {
    mode: "transaction_price",
    title: "قيمة الصفقة",
    label: "قيمة الصفقة . ريال سعودي",
    stops: [
      { value: 0, color: "hsl(0, 0%, 80%)", percent: "0%" },
      { value: 4167, color: "hsl(86, 83%, 65%)", percent: "5%" },
      { value: 70000, color: "hsl(64, 63%, 53%)", percent: "20%" },
      { value: 100000, color: "hsl(42, 80%, 55%)", percent: "30%" },
      { value: 175000, color: "hsl(25, 100%, 61%)", percent: "40%" },
      { value: 270000, color: "hsl(8, 100%, 66%)", percent: "50%" },
      { value: 400000, color: "hsl(348, 100%, 66%)", percent: "60%" },
      { value: 570000, color: "hsl(331, 83%, 60%)", percent: "75%" },
      { value: 850000, color: "hsl(312, 56%, 51%)", percent: "90%" },
      { value: 1390000, color: "hsl(266, 45%, 46%)", percent: "100%" },
    ],
    ranges: ["0k - 70k", "70k - 175k", "175k - 400k", "400k - 850k", ">10000k"],
  },
  {
    mode: "zoning_color",
    title: "استخدام الأراضي ",
    label: "",
    legends: [
      {
        value: "مناطق مفتوحة",
        color: "#a0cbe8",
      },
      {
        value: "شقق تجاري",
        color: "#fa6d6d",
      },
      {
        value: "مرافق",
        color: "#bab0ac",
      },
      {
        value: "تجاري",
        color: "#e74545",
      },
      {
        value: "سكني",
        color: "#f1ce63",
      },
      {
        value: "زراعي",
        color: "#8cd17d",
      },
    ],
  },
];

export const TRANSACTIONS_PERIODS = [
  {
    value: "0",
    title: "آخر شهر",
  },
  {
    value: "1",
    title: "آخر 3 أشهر",
  },
  {
    value: "2",
    title: "آخر 6 أشهر",
  },
  {
    value: "3",
    title: "آخر سنة",
  },
  {
    value: "5",
    title: "كل الصفقات",
  },
  {
    value: "custom",
    title: "تخصيص",
  },
];

export const INITIAL_PERIOD = 1;

export const BROKER_STATUS_MAPPING = {
  draft: { title: "مسودة", color: "#F2F2F2" },
  in_progress: { title: "تحت المعالجة", color: "#E4F2FD" },
  submitted: { title: "تم التسليم", color: "#a0cbe8" },
  approved: { title: "موافق عليه", color: "#BFF9C8" },
  rejected: { title: "مرفوض", color: "#FFD0D0" },
  not_registerd: { title: "غير مسجل", color: "#C5C7D2" },
};
